// Storage configuration (public, non-secret parts only).
// The browser holds NO storage credentials: uploads go through
// /api/storage/presign (see src/utils/uploadToStorage.ts), reads are plain
// URLs on the public asset host.

export const AWS_CONFIG = {
  // Public URL for R2 (custom domain with CDN caching)
  publicUrl: ((import.meta.env.VITE_R2_PUBLIC_URL || '').trim() || 'https://assets.gathrxr.com').replace(/\/+$/, ''),

  folders: {
    environments: 'environments/',
    skyboxes: 'skyboxes/',
    content: 'content/',
    avatars: 'avatars/'
  },

  uploadSettings: {
    environment: {
      folder: 'environments/',
      allowedFormats: ['glb', 'gltf'],
      maxFileSize: 5 * 1024 * 1024 * 1024,
      contentTypes: {
        'glb': 'model/gltf-binary',
        'gltf': 'model/gltf+json'
      }
    },
    skybox: {
      folder: 'skyboxes/',
      allowedFormats: ['jpg', 'jpeg', 'png', 'hdr', 'exr'],
      maxFileSize: 500 * 1024 * 1024,
      contentTypes: {
        'jpg': 'image/jpeg',
        'jpeg': 'image/jpeg',
        'png': 'image/png',
        'hdr': 'image/vnd.radiance',
        'exr': 'image/x-exr'
      }
    },
    content: {
      folder: 'content/',
      allowedFormats: ['glb', 'gltf', 'jpg', 'jpeg', 'png', 'mp3', 'wav', 'ogg', 'splat', 'spz', 'ply'],
      maxFileSize: 1024 * 1024 * 1024,
      contentTypes: {
        'glb': 'model/gltf-binary',
        'gltf': 'model/gltf+json',
        'jpg': 'image/jpeg',
        'jpeg': 'image/jpeg',
        'png': 'image/png',
        'mp3': 'audio/mpeg',
        'wav': 'audio/wav',
        'ogg': 'audio/ogg',
        'splat': 'application/octet-stream',
        'spz': 'application/octet-stream',
        'ply': 'application/octet-stream'
      }
    },
    texture: {
      folder: 'textures/',
      allowedFormats: ['jpg', 'jpeg', 'png', 'zip'],
      maxFileSize: 500 * 1024 * 1024,
      contentTypes: {
        'jpg': 'image/jpeg',
        'jpeg': 'image/jpeg',
        'png': 'image/png',
        'zip': 'application/zip'
      }
    }
  }
};

export const getS3FileUrl = (key: string) => `${AWS_CONFIG.publicUrl}/${key}`;

export const validateFile = (file: File, uploadType: 'environment' | 'skybox' | 'content' | 'texture'): string | null => {
  const settings = AWS_CONFIG.uploadSettings[uploadType];
  if (file.size > settings.maxFileSize) {
    return `File too large. Maximum size is ${settings.maxFileSize / (1024 * 1024 * 1024)}GB`;
  }
  const extension = file.name.split('.').pop()?.toLowerCase();
  if (!extension || !settings.allowedFormats.includes(extension)) {
    return `Invalid file format. Allowed formats: ${settings.allowedFormats.join(', ')}`;
  }
  return null;
};
